import * as React from 'react';
import classNames from 'classnames';

import { DeleteButton } from '../../../../../DeleteButton';
import { HeaderImage } from '../../../../../HeaderImage';
import { FavoriteButton } from '../../../../../FavoriteButton';
import * as styles from './HeaderField.css';

export interface IHeaderFieldProps {
  dragging?: boolean;
  onClick: () => void;
  onDelete: () => void;
  onFavoriteChange: () => void;
  favorite: boolean;
  published: boolean;
  imageUrl: string;
  title: string;
}

const HeaderFieldComponent: React.FC<IHeaderFieldProps> = ({
  favorite,
  dragging,
  imageUrl,
  published,
  onClick,
  onDelete,
  onFavoriteChange,
  title,
}) => {
  return (
    <div className={classNames(styles['field'], { [styles['field--dragging']]: dragging })} onClick={onClick}>
      <div className={classNames(styles['image'], !published && styles['image--unpublished'])}>
        <HeaderImage url={imageUrl} alt={title} type="l" />
      </div>

      <div className={styles['controls']}>
        <DeleteButton type="l" onClick={onDelete} />
        <FavoriteButton active={favorite} type="l" onClick={onFavoriteChange} />
      </div>
    </div>
  );
};

export const HeaderField = React.memo(HeaderFieldComponent);
